import RichContent from '../util/rich/RichContent';

import {List,RefreshControl,ActivityIndicator} from 'antd-mobile'

const server = window.server;

class Main extends React.Component {
	constructor(props) { 
		super(props);
	}
	render() {
		const {data} = this.props;
		let list = data ? data.dbs : [];
		if (data && list) {
			list = this.getList(list, data.dbsreply);
		}
		if (!data) {
			return (
				<div className="csm-app-baseinfo-loading">
        			<ActivityIndicator animating size="large" style={{backgroundColor:'#000'}}/>
        		</div>
			)
		}
		return (
			<div className="csm-app-comment">
			{
				list.map(dbs => {
					return (
						<List key={dbs.ds_id}>
							<List.Item>
								<a>{ dbs.m_name }</a>
								&nbsp;&nbsp;&nbsp;
								{ dbs.ds_createtime }
								&nbsp;&nbsp;&nbsp;
								{ this.getDsType(dbs.ds_type) }
								&nbsp;&nbsp;&nbsp;
								{ dbs.ds_score } 分		
								&nbsp;&nbsp;&nbsp;
								{ dbs.ds_num } 楼	 	
							</List.Item>
							<List.Item>
								<RichContent value={dbs.ds_content} />
								{
									dbs.children && 				        	
									<div className="csm-app-comment-list-inner">
									{
										dbs.children.map(yang => {
											return <List key={yang.ds_num}>
												<List.Item>
													<a>{ yang.m_name }</a>
													&nbsp;&nbsp;&nbsp;
													{ yang.ds_createtime }		
												</List.Item>
												<List.Item>
													<RichContent value={yang.ds_content} />
												</List.Item>
											</List>				        				
										})
									}
									</div>
								}

							</List.Item>
						</List>
					)
				})
			}
			</div>
		)
	}
	getList(list, dbsreply) {
		const that = this;
		dbsreply.forEach(dr => {
			let parent = that.getParent(dr.ds_fid, list);
			if (!parent) return;
			if (!parent.children) {
				parent.children = [dr];
			} else {
				parent.children.push(dr);
			}
		});
		return list;
	}
	getParent(fid, list) {
		const temp = list.filter(el => {
			return el.ds_id == fid;
		});
		return temp.length ? temp[0] : "";
	}
	getDsType(dstype) {
		if(dstype==0) {
			return "普通";
		}
		else if(dstype==1) {
			return "咨询";
		}
		else if(dstype==2) {
			return "需求";
		}
		else if(dstype==3) {
			return "问题";
		}
		return "普通";
	}
}

export default Main

/*
class Main extends React.Component {
	constructor(props) { 
		super(props);
	}
	componentWillMount() {
		this.pageindex = 0;
		this.state = {
			loading: false
		}
	}
	render() {
		const {app} = this.props;
		
		console.log("Component:",app);
		var list = app ? app.dbs : [];
		if (list) {
			list = this.calYang(list, app.dbsreply);
		}
		if (!app) {
			return <div  style={{"position": "fixed", "left": "50%", "top": "50%", "zIndex": "1000", "marginLeft": "-10px", "marginTop": "-10px"}}>
        		<ActivityIndicator animating size="large" />
        	</div>
		}
		return <div className="fy-comment" onTouchMove={ this.onLoadGuess.bind(this) }>
			{
				list.map(dbs => {
					return <List key={dbs.ds_id}>
				        <List.Item>
							<a>{ dbs.m_name }</a>
							&nbsp;&nbsp;&nbsp;
							{ dbs.ds_createtime }
							&nbsp;&nbsp;&nbsp;
							{ this.getDsType(dbs.ds_type) }
							&nbsp;&nbsp;&nbsp;
							{ dbs.ds_score } 分		
							&nbsp;&nbsp;&nbsp;
							{ dbs.ds_num } 楼	 	
				        </List.Item>
				        <List.Item style={{"padding": "0.08rem 0.32rem"}}>
				        	<RichContent value={dbs.ds_content} />
				        	{
				        		dbs.children && 				        	
				        		<div className="fy-comment-yang">
				        		{
				        			dbs.children.map(yang => {
						        		return <List key={yang.ds_num}>
									        <List.Item>
												<a>{ yang.m_name }</a>
												&nbsp;&nbsp;&nbsp;
												{ yang.ds_createtime }		
									        </List.Item>
									         <List.Item style={{"padding": "0 0.32rem"}}>
									         	<RichContent value={yang.ds_content} />
									         </List.Item>
						        		</List>				        				
				        			})
				        		}
					        	</div>
				        	}

				        </List.Item>
				    </List>
				})
			}
			{
				this.state.loading &&
				<div style={{"position": "fixed", "left": "50%", "top": "50%", "zIndex": "1000", "marginLeft": "-10px", "marginTop": "-10px"}}>
	        		<ActivityIndicator animating size="large" />
	        	</div>				
			}

		</div>
	}
	getDsType(dstype) {
		if(dstype==0) {
			return "普通";
		}
		else if(dstype==1) {
			return "咨询";
		}
		else if(dstype==2) {
			return "需求";
		}
		else if(dstype==3) {
			return "问题";
		}
		return "普通";
	}
	onLoadGuess(event) {
		if (!this.props.app) return;
		var ready = (document.body.scrollHeight - document.body.scrollTop - document.documentElement.clientHeight < 100) 
			&& (!this.state.loading)
			&& (this.pageindex + 1 < this.props.app.dbscount / 5);
		if (!ready) return;
		this.setState({
			loading: true
		});
		this.pageindex += 1;
		const that = this;
		API.load(this.props.app.app, this.pageindex).then(function(data) {
			var newbees = data.dbs;
			var yangs = data.dbsreply;
			that.push(newbees, yangs);
		});
	}
	push(newbees, yangs) {
		this.props.app.dbs = this.props.app.dbs.concat(newbees);
		this.props.app.dbsreply = this.props.app.dbsreply.concat(yangs);
		this.props.actions.pojo();
		this.setState({
			loading: false
		});
	}
	calYang(list, yangs) {
		const that = this;
		yangs.forEach(yang => {
			var parent = that.yangGetParent(yang.ds_fid, list);
			if (!parent) return;
			if (!parent.children) {
				parent.children = [yang];
			} else {
				parent.children.push(yang);
			}
		});
		return list;
	}
	yangGetParent(fid, list) {
		var temp = list.filter(el => {
			return el.ds_id == fid;
		});
		return temp.length ? temp[0] : "";
	}
}	


import 'whatwg-fetch';
const API = {
	load: function(app, page) {
		var url = window.server + "/v1/deb/" + app.sw_id,
			data = {
				sw_id: app.sw_id,
				s_number: app.s_number,
				pageSize: 5,
				current: page + 1
			},
			ya = function(data) {
				var result = [];
				for (var key in data) {
					if (Object.prototype.hasOwnProperty.call(data, key)) {
						result.push(encodeURIComponent(key) + "=" + encodeURIComponent(data[key]));
					}
				}
				return result.join("&");
			}(data);
		return fetch(url + "?" + ya).then(function(response) {
			return response.json();
		}).catch(function(error) {
			console.log(error);
		});
	}
}
*/


// WEBPACK FOOTER //
// ./project/components/app/Comment.js